export { AnimatedModal } from "./animated-modal";
export type {
    AnimatedModalContent,
    AnimatedModalProps
} from "./animated-modal";
